export default __webpack_public_path__ + "static/media/Logo.f680f47a.png";